import style from "./AppDrugPage.module.scss";
import classNames from "classnames";
import PropTypes from "prop-types";
import SearchResultItem from "../SearchResults/SearchResultItem";
import { mapDrugs } from "../SearchResults/mapper/mapDrugs";

const AppDrugSearchResults = ({ drugResults }) => {
  const searchResults = mapDrugs(drugResults);

  return (
    <div className={classNames(style.searchPage, "columnBlockLayout regular")}>
      <ul className={style.resultList}>
        {searchResults && searchResults.length > 0 ? (
          searchResults.map((result, index) => (
            <SearchResultItem isAppMode={true} searchResult={result} key={index} />
          ))
        ) : (
          <div className={classNames("size-18", style.noResultsText)}>
            {`No drug indications found.`}
          </div>
        )}
      </ul>
    </div>
  );
};

AppDrugSearchResults.propTypes = {
  drugResults: PropTypes.arrayOf(
    PropTypes.shape({
      title: PropTypes.string,
      guideline: PropTypes.string,
      summary: PropTypes.string,
      url: PropTypes.string,
    }),
  ).isRequired,
};

export default AppDrugSearchResults;
